import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {

  constructor(private activatedActivated: ActivatedRoute) {}
  
  error_code = this.activatedActivated.snapshot.queryParams['code'];

  
  ngOnInit(): void {
  }

}
